import NumberHelper from "./NumberHelper";
import { ZONE_PARAMETER_TYPES } from "./ZoneParametersHelper";

const isPresent = value => value !== null && typeof value !== "undefined";

export const SUPPLY_DEMAND_ALERT_STATES = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

export default class ActiveRiskRewardHelper {
  static hasRequiredStaticFields(resultMetaData) {
    if (!resultMetaData) {
      return false;
    }

    if (resultMetaData.state !== SUPPLY_DEMAND_ALERT_STATES.ACTIVE) {
      return false;
    }

    const { type, stop_loss: stopLoss, take_profit: takeProfit } = resultMetaData;

    if (
      type !== ZONE_PARAMETER_TYPES.DEMAND &&
      type !== ZONE_PARAMETER_TYPES.SUPPLY
    ) {
      return false;
    }

    return isPresent(stopLoss) && isPresent(takeProfit);
  }

  /**
   * @param {object} resultMetaData — row fields (type, stop_loss, take_profit, state)
   * @param {number|null|undefined} currentPrice — live quote close from Firebase
   */
  static calculate(resultMetaData, currentPrice) {
    if (!ActiveRiskRewardHelper.hasRequiredStaticFields(resultMetaData)) {
      return null;
    }

    if (!isPresent(currentPrice)) {
      return null;
    }

    const numericCurrentPrice = Number(currentPrice);
    const stopLoss = Number(resultMetaData.stop_loss);
    const takeProfit = Number(resultMetaData.take_profit);

    if (
      !Number.isFinite(numericCurrentPrice) ||
      !Number.isFinite(stopLoss) ||
      !Number.isFinite(takeProfit)
    ) {
      return null;
    }

    if (resultMetaData.type === ZONE_PARAMETER_TYPES.DEMAND) {
      const reward = takeProfit - numericCurrentPrice;
      const risk = numericCurrentPrice - stopLoss;
      if (risk === 0) {
        return null;
      }
      const ratio = reward / risk;
      return ratio < 0 ? null : ratio;
    }

    const reward = numericCurrentPrice - takeProfit;
    const risk = stopLoss - numericCurrentPrice;
    if (risk === 0) {
      return null;
    }
    const ratio = reward / risk;
    return ratio < 0 ? null : ratio;
  }

  static render(resultMetaData, currentPrice, format = "number_two_decimal") {
    const value = ActiveRiskRewardHelper.calculate(resultMetaData, currentPrice);

    if (value === null) {
      return null;
    }

    return NumberHelper.render(value, format);
  }

  static shouldRenderDash(props) {
    return !ActiveRiskRewardHelper.hasRequiredStaticFields(props?.resultMetaData);
  }
}
